import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  ranking = 1,
  rules = 2,
}

export enum WeeklyRankEnum {
  giver = 1,
  receiver = 2,
}

export enum LastWeekEnum {
  giver = 1,
  receiver = 2,
}
// 获取基础配置信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=31602262
export const future_star_config = createAsyncThunk(
  'future_star_config',
  async (arg, store: any) => {
    const arObj =
      store.getState().env.deviceinfo.h_area_code === 0 ? {tab_id: 1} : {}
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'send_gift_id' | 'receive_gift_id'>>
    >(
      '/live/commonactivity/future_star_config',
      {
        ...store.getState().env.deviceinfo,
        ...arObj,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// h5 获取周星礼物接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17589968
export const get_gift = createAsyncThunk(
  'get_gift',
  async (arg: {activity_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'gift_list'>>>(
      '/live/commonactivity/get_gift',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// h5 获取榜单时间数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=17592895
export const get_rank_time = createAsyncThunk(
  'get_rank_time',
  async (arg: {activity_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'round_list' | 'start_time' | 'end_time'>>
    >('/live/commonactivity/get_rank_time', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface HiyaRes<T> {
  ret: number
  data: T
}
interface GiftItemType {
  // 礼物id
  giftId: number
  // 礼物图片url
  url: string
  // 礼物名字
  name: string
  // 礼物单价
  score: number
}
interface RoundType {
  round_index: number
  round_st: string
  round_et: string
  round_expire: number
}

interface InitialStateType {
  send_gift_id?: number
  receive_gift_id?: number
  gift_list?: Array<GiftItemType>
  round_list?: Array<RoundType>
  start_time?: string
  end_time?: string
  weeklyExpire?: number
  lastWeekExpire?: string
  activityExpire?: string
}
const initialState: InitialStateType = {}
export const WeekGiftStarSlice = createSlice({
  name: 'WeekGiftStar',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(future_star_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_gift.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(get_rank_time.fulfilled, (state, action) => {
      const {round_list, start_time, end_time} = action.payload
      if (!round_list || !round_list.length) {
        return
      }
      const ret: any = {
        weeklyExpire: round_list[0].round_expire || 0,
        activityExpire:
          start_time && end_time
            ? `${round_list[0].round_st
                .split(' ')[0]
                .split('-')
                .join('.')}-${round_list[0].round_et
                .split(' ')[0]
                .split('-')
                .join('.')}`
            : '',
        lastWeekExpire:
          round_list.length > 1
            ? `${round_list[1].round_st
                .split(' ')[0]
                .split('-')
                .join('.')}-${round_list[1].round_et
                .split(' ')[0]
                .split('-')
                .join('.')}`
            : '',
      }

      Object.assign(state, ret)
    })
  },
})
export default WeekGiftStarSlice.reducer
